export const jsonInputSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  title: "JsonInputExample",
  type: "array",
  items: {
    type: "object",
    properties: {
      id: { type: "string" },
      titulo: { type: "string" },
      tipo: { type: "number" },
      font: { type: ["string", "null"] },
      mapRefId: { type: ["string", "null"] },
      img: { type: "string" },
      elementConfig: {
        type: "object",
        properties: {
          config: {
            type: "object",
            properties: {
              hosts: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    host: { type: "string" },
                    tags: { type: "array", items: {} },
                    itens: { type: "array", items: {} },
                    hostid: { type: "string" },
                    hostname: { type: "string" },
                    interfaces: { type: "array", items: {} },
                  },
                  required: [
                    "host",
                    "tags",
                    "hostid",
                    "hostname",
                    "interfaces",
                  ],
                  additionalProperties: false,
                },
              },
              produtoId: { type: "string" },
              coordenadas: {
                type: "object",
                properties: {
                  lat: { type: ["number", "string"] },
                  long: { type: ["number", "string"] },
                },
                required: ["lat", "long"],
                additionalProperties: false,
              },
            },
            required: ["hosts", "produtoId", "coordenadas"],
            additionalProperties: false,
          },
        },
        required: ["config"],
        additionalProperties: false,
      },
      element: {
        type: "array",
        items: {},
      },
    },
    required: [
      "id",
      "titulo",
      "tipo",
      "font",
      "mapRefId",
      "img",
      "elementConfig",
      "element",
    ],
    additionalProperties: false,
  },
};
